import { render, staticRenderFns } from "./AdminUserManageDetail.vue?vue&type=template&id=0da18ca2&"
import script from "./AdminUserManageDetail.vue?vue&type=script&lang=js&"
export * from "./AdminUserManageDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports